import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PieChartBaseComponent } from './pie-chart-base/pie-chart-base.component';
import { PieChartWrapperComponent } from './pie-chart-wrapper/pie-chart-wrapper.component';
import { ChartLegendComponent } from './chart-legend/chart-legend.component';
import { LineChartBaseComponent } from './line-chart-base/line-chart-base.component';
import { SunburstChartBaseComponent } from './sunburst-chart-base/sunburst-chart-base.component';
import { SunburstChartWrapperComponent } from './sunburst-chart-wrapper/sunburst-chart-wrapper.component';
import { CircleChartInfoComponent } from './circle-chart-info/circle-chart-info.component';
import { TimelineChartBaseComponent } from './timeline-chart-base/timeline-chart-base.component';
import { TimelineChartWrapperComponent } from './timeline-chart-wrapper/timeline-chart-wrapper.component';
import { DurationFormatPipe } from '../pipes/duration-format.pipe';
import { BarChartBaseComponent } from './bar-chart-base/bar-chart-base.component';
import { BarChartWrapperComponent } from './bar-chart-wrapper/bar-chart-wrapper.component';
import { MultiLineChartComponent } from './multi-line-chart/multi-line-chart.component';
import { StackedBarChartComponent } from './stacked-bar-chart/stacked-bar-chart.component';

@NgModule({
  declarations: [
    PieChartBaseComponent,
    PieChartWrapperComponent,
    ChartLegendComponent,
    SunburstChartBaseComponent,
    SunburstChartWrapperComponent,
    CircleChartInfoComponent,
    LineChartBaseComponent,
    TimelineChartBaseComponent,
    TimelineChartWrapperComponent,
    BarChartBaseComponent,
    BarChartWrapperComponent,
    MultiLineChartComponent,
    StackedBarChartComponent,
  ],
  imports: [CommonModule],
  exports: [
    PieChartWrapperComponent,
    SunburstChartWrapperComponent,
    LineChartBaseComponent,
    TimelineChartWrapperComponent,
    BarChartBaseComponent,
    BarChartWrapperComponent,
    MultiLineChartComponent,
    StackedBarChartComponent,
  ],
  providers: [DurationFormatPipe],
})
export class ChartsModule {}
